var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsMenuIconHoverV4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66663 2.96297C2.33935 2.96297 2.07404 3.22828 2.07404 3.55556V12.1481V12.1482C2.07404 12.3067 2.13628 12.4507 2.23767 12.557C2.24872 12.5686 2.26024 12.5797 2.27219 12.5904C2.37695 12.6839 2.51515 12.7407 2.66663 12.7407H12.1481C12.2981 12.7407 12.4351 12.685 12.5395 12.5931C12.5759 12.5611 12.6085 12.5245 12.6363 12.4841C12.6769 12.4252 12.7072 12.3586 12.7244 12.2869L14.2027 6.66933C14.2494 6.49162 14.2111 6.30226 14.0989 6.15672C13.9867 6.01118 13.8134 5.92593 13.6296 5.92593H12.7407V4.74074C12.7407 4.41347 12.4754 4.14815 12.1481 4.14815H7.06024L6.04862 3.13653C5.93748 3.0254 5.78676 2.96297 5.62959 2.96297H2.66663ZM11.5555 5.92593V5.33334H6.81478C6.65761 5.33334 6.50688 5.2709 6.39575 5.15977L5.38413 4.14815H3.25922V7.5678L3.57503 6.36771C3.64354 6.10738 3.87892 5.92593 4.14812 5.92593H11.5555ZM3.43535 11.5556L4.60494 7.11111H12.8609L11.6913 11.5556H3.43535Z",
    fill: "#3537E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsMenuIconHoverV4);
export default __webpack_public_path__ + "static/media/documents-menu-icon-hover-v4.e1a51af2eefbcff432395f1c65028227.svg";
export { ForwardRef as ReactComponent };